import * as React from 'react';
import { DropDown, IDropDownProps } from './DropDown';
import { buildDropdownOptionsFromArray } from '~utils/DropDownUtils';
import { observer } from 'mobx-react';

export interface IDateYearProps extends Omit<IDropDownProps, 'options'> {
    offsets?: number[];
}

const defaultOffsets = [-20, -121];

export const DateYear = observer(({ offsets = defaultOffsets, ...restProps }: IDateYearProps) => {
    const [start = 0, end = 0] = offsets;
    const baseYear = new Date().getFullYear();
    const startYear = baseYear + start;
    const endYear = baseYear + end;
    const dateRange = Array.from({ length: startYear - endYear }, (_, idx) =>
        (startYear - idx).toString()
    );

    const options = buildDropdownOptionsFromArray(dateRange);

    return <DropDown {...restProps} options={options} />;
});
